export default __webpack_public_path__ + "static/media/ibp_Fraunhofer.10e21926.gif";